export const isAbortError = (error: unknown): boolean => {
	if (!error || typeof error !== 'object') return false

	const typed = error as { name?: string; cause?: { name?: string } }

	return typed.name === 'AbortError' || typed.cause?.name === 'AbortError'
}
